import { pick } from 'lodash';
import User from '@/shared/models/User';
import { isPresent } from '@/shared/utils/typescript';
import FluidSpecification from './FluidSpecification';

export interface FluidTypeId {__fluidTypeId: number;}

export interface FluidId {__fluidId: number;}

export type FluidUnit = string;

export interface FluidData {
  quantity: number;
  specification: FluidSpecification | null;
  productCode: string | null;
}

export default class Fluid {
  id: FluidId | null = null;
  typeId!: FluidTypeId;
  description = '';
  isLiquid = false;
  unit: FluidUnit = '';
  quantity: number | null = null;
  productCode: string | null = null;
  maxValue = 0;
  stepValue = 0;
  specifications: Array<FluidSpecification> = [];
  modifiedBy: User | null = null;

  isPresent(): boolean {
    return isPresent(this.id);
  }

  getSelectedSpecification(): FluidSpecification | undefined {
    return this.specifications.find(s => s.isSelected);
  }

  getSpecificationDescription(): string | undefined {
    return this.getSelectedSpecification()?.description;
  }

  clear(): void {
    Object.assign(this, pick(new Fluid(), 'id', 'quantity', 'productCode', 'specifications', 'modifiedBy'));
  }
}